<template>
  <div class="card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5>Ajouter Bon de Retour (Client)</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-md-9">
          <div class="form-group mb-3">
            <label>Client :</label>
            <v-select
              class="custom-select-height"
              :options="clientList"
              v-model="client"
              label="store"
            >
              <template #option="{ city_return, store, nb_colis }">
                <span v-if="city_return"
                  >{{ store }} ({{ city_return }}) - (
                  {{ nb_colis }} colis)</span
                >
                <span v-else
                  >{{ store }} {{ city_return }} - ( {{ nb_colis }} colis)</span
                >
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-md-3">
          <button
            class="btn btn-primary"
            @click="addReturnNote"
            v-if="auth.can('ADD_BR_C')"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted } from "vue";
import { ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // Declare reactive variables
    const clientList = ref<Array<any>>([]);
    const client = ref<any>({});
    const isLoader = ref(false);

    async function addReturnNote() {
      if (Object.keys(client.value).length === 0) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }
      const data = new FormData();
      data.append("type", "2");
      data.append("cstmr_id", client.value.id);
      data.append("cstmr_name", client.value.name);
      data.append("user_id", user?.id);
      data.append("user_name", user?.name);

      isLoader.value = true;
      try {
        const res = await api.post(`/api/auth/add_brn_agency`, data);
        isLoader.value = false;
        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "EditReturnPage",
            params: {
              id: res.data.RtnNote.id,
              refNote: res.data.RtnNote.note_ref,
            },
          });
          window.open(routeData.href, "_blank");
        }
      } catch (error) {
        isLoader.value = false;
        showToast("Something went wrong! Please try again", "error");
      }
    }

    onMounted(async () => {
      // Load agencies list on mount
      try {
        const res = await api.get("/api/auth/list_cstmr_return");
        clientList.value = res.data;
      } catch (error) {
        showToast("Impossible de charger les agences", "error");
      }
    });

    return {
      clientList,
      client,
      isLoader,
      auth,
      addReturnNote,
    };
  },
});
</script>
